import {getIpxUser, getIpxWorldUserRank, getIpxWorldHistory, upsertIpxWorldHistory} from "api-v3";
import {convertMilliseconds, convertToTimeString} from "utils";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import View from "./View";

export default function Container({isCloseUsable = false, singlePopup = false, dismiss}) {
  const {id} = useSelector(state => state.userinfo);
  const gameState = useSelector(state => state.game);
  const [myRank, setMyRank] = useState({});
  const [ranks, setRanks] = useState([]);
  const [username, setUsername] = useState("");

  useEffect(() => {
    setIPXUsername();
    getRunnerzRank();
    get30Ranks();
  }, []);

  useEffect(() => {
    if (gameState.messageFromGame?.record) {
      const record = convertRecord(gameState.messageFromGame.record * 1000);
      const updateRunnerzRecord = async record => {
        try {
          await upsertIpxWorldHistory({worldType: "RUNNERZ", time: record});
          await get30Ranks();
          const res = await getIpxWorldUserRank({worldType: "RUNNERZ"});
          setMyRank(res.message);
        } catch (error) {
          console.log(error);
        }
      };

      updateRunnerzRecord(record);
    }
  }, [gameState]);

  const getRunnerzRank = async () => {
    try {
      const res = await getIpxWorldUserRank({worldType: "RUNNERZ"});
      setMyRank(res.message);
    } catch (error) {
      console.log(error);
    }
  };

  const get30Ranks = async () => {
    try {
      const res = await getIpxWorldHistory({worldType: "RUNNERZ", offset: 0, limit: 30});
      setRanks(res.message);
    } catch (error) {
      console.log(error);
    }
  };

  const setIPXUsername = async () => {
    const res = await getIpxUser();
    if (res.code === 200) {
      setUsername(res.message.name);
    }
  };

  const convertRecord = record => {
    if (!record || record >= 3600000) return "-";
    const {minutes, seconds, milliseconds} = convertMilliseconds(record);
    return convertToTimeString([minutes, seconds, milliseconds]);
  };

  return (
    <View
      myRank={myRank}
      ranks={ranks}
      myId={id}
      isCloseUsable={isCloseUsable}
      singlePopup={singlePopup}
      name={username}
      dismiss={dismiss}
    />
  );
}
